import styled from 'styled-components';

import { FilterChipCloseIcon } from '../../../assets';
import { ThemeProp } from '../../../theme/Themes';

export const FilterChipContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${({ theme }: ThemeProp) => theme.colors.main.c100};
  border-radius: 0.5rem;
  padding: 0.375rem 0.5rem;
  color: ${({ theme }: ThemeProp) => theme.colors.main.c600};
  max-width: 12.5625rem;
  /* overflow: hidden; */
  font-size: ${({ theme }: ThemeProp) => theme.fontSize.s};
  line-height: 1.1375rem;
`;

export const FilterChipIcon = styled.div`
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.375rem;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }

  svg,
  path,
  circle,
  rect {
    stroke: ${({ theme }: ThemeProp) => theme.colors.main.c600};
  }
`;

export const FilterChipText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 8.5rem;
`;

export const FilterChipActions = styled.div`
  display: inline-flex;
`;

export const StyledCloseIcon = styled(FilterChipCloseIcon)`
  width: 0.875rem;
  height: 0.875rem;
  stroke: ${({ theme }: ThemeProp) => theme.colors.main.c300};
  cursor: pointer;
  margin-left: 0.375rem;
`;

export const FilterChipSpacer = styled.div`
  flex-grow: 1;
`;
